module.exports = __webpack_public_path__ + "static/media/trade.e123ebb6.mp4";